import { Select } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import { InputSelect } from './styles';

import api from '../../services/api';

export function SearchInputMunicipios({
  uf,
  value,
  onChange,
  placeholder,
  id,
}) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    setSearch('');
    setData([]);
  }, [uf, value]);

  useEffect(() => {
    const term = search || String(value ?? '').split('#')[0];
    if (!uf || !term) return undefined;

    let active = true;
    const timeout = setTimeout(async () => {
      try {
        const field = /^\d+$/.test(term) ? 'CodigoIbge' : 'Nome';
        const response = await api.get(
          `/municipio/list?UF=${encodeURIComponent(
            uf
          )}&NumeroRegistros=999&${field}=${encodeURIComponent(term)}`
        );
        if (!active) return;

        const items = response.data.items || [];
        setData(items);

        // Converte o código/nome recebido no cadastro para o valor do seletor.
        if (!search && value != null && !String(value).includes('#')) {
          const selected = items.find(
            item =>
              String(item.codigoIbge) === String(value) ||
              item.nome.toLocaleLowerCase() ===
                String(value).toLocaleLowerCase()
          );
          if (selected) {
            onChangeRef.current?.(`${selected.codigoIbge}#${selected.nome}`);
          }
        }
      } catch (error) {
        if (active) setData([]);
      }
    }, 300);

    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [uf, value, search]);

  const selectedParts = String(value ?? '').split('#');
  const options = data.map(item => ({
    value: `${item.codigoIbge}#${item.nome}`,
    label: item.nome,
  }));
  if (
    selectedParts.length === 2 &&
    !options.some(item => item.value === value)
  ) {
    options.push({ value, label: selectedParts[1] });
  }

  return (
    <InputSelect
      id={id}
      showSearch
      optionFilterProp="children"
      value={value ?? undefined}
      popupMatchSelectWidth={false}
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      filterOption={false}
      onSearch={setSearch}
      onChange={onChange}
      notFoundContent={null}
      allowClear
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </InputSelect>
  );
}
